import styled from 'styled-components';

import { Checkbox } from '@/ui/Checkbox';
import { LearnerRow } from '@/features/journey/admin/hooks/useLearnersColumnsDeclaration';

export const RootStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
`;

export const JourneyInsightsParticipantsCheckbox = ({
  row: { id, selected, onToggleSelected },
}: {
  row: LearnerRow;
}): React.ReactElement => (
  <RootStyled>
    <Checkbox checked={selected} onChange={() => onToggleSelected(id)} />
  </RootStyled>
);
